import type { Employee } from "@/pages/human-resources/time-management/business/Employee.ts";

export class EmployeesContractsManager {
  private readonly relatedSitesIds: Set<string>;
  private readonly employeesIds: Set<string>;
  private readonly employeesById: Map<string, Employee>;

  constructor(
    public readonly siteId: string,
    public readonly startDate: Date,
    public readonly endDate: Date,
    employees: Employee[],
    visibleSitesIds: Set<string>,
  ) {
    this.relatedSitesIds = new Set<string>();
    this.employeesIds = new Set<string>();
    this.employeesById = new Map<string, Employee>();
    employees.forEach((employee) => {
      this.employeesById.set(employee.id, employee);
      this.employeesIds.add(employee.id);
      employee.contracts.otherSitesIds().forEach((id) => {
        if (visibleSitesIds.has(id)) this.relatedSitesIds.add(id);
      });
    });
  }

  public listEmployees(): Employee[] {
    return [...this.employeesById.values()];
  }

  public getRelatedSitesIds(): Set<string> {
    return this.relatedSitesIds;
  }

  public getEmployeesIds(): Set<string> {
    return this.employeesIds;
  }
}
